/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */

import { Levels } from "@nuance/hierarchical-settings-ui-domain";
import { CmdBuilder } from "@nuance/hap-components";

/**
 * State for AccessLevelSelection component
 */
export interface IAccessLevelSelectionState {
    systemChecked: boolean;
    orgChecked: boolean;
    siteChecked: boolean;
    groupChecked: boolean;
    userChecked: boolean;
}

/**
 * Commands for the AccessLevelSelection component.
 */
export class AccessLevelSelectionCommands {
    constructor() {
        const cb = new CmdBuilder();
        const cmds = {
            toggleSystem: cb.bindCmdNP(this.toggleSystemHandler),
            toggleOrg: cb.bindCmdNP(this.toggleOrgHandler),
            toggleSite: cb.bindCmdNP(this.toggleSiteHandler),
            toggleGroup: cb.bindCmdNP(this.toggleGroupHandler),
            toggleUser: cb.bindCmdNP(this.toggleUserHandler)
        };

        this.Cmds = cmds;
        this.Reducer = cb.buildReducer<IAccessLevelSelectionState>(cmds);
    }

    readonly Cmds;
    readonly Reducer;

    /**
     * Calculates the current components effective access level based on
     * the items currently checked.
     *
     * @param state Current component state
     * @returns Current effective access level
     */
    CalculateAccessLevel = (state: IAccessLevelSelectionState): number => {
        const accessLevel: number =
            (state.systemChecked ? (Levels.System as number) : 0) |
            (state.orgChecked ? (Levels.Org as number) : 0) |
            (state.siteChecked ? (Levels.Site as number) : 0) |
            (state.groupChecked ? (Levels.Group as number) : 0) |
            (state.userChecked ? (Levels.User as number) : 0);

        return accessLevel;
    };

    /////////////////////////////////////////////////////////////////
    // Command handlers
    /////////////////////////////////////////////////////////////////

    toggleSystemHandler = (state: IAccessLevelSelectionState): IAccessLevelSelectionState => {
        state.systemChecked = !state.systemChecked;
        return state;
    };

    toggleOrgHandler = (state: IAccessLevelSelectionState): IAccessLevelSelectionState => {
        state.orgChecked = !state.orgChecked;
        return state;
    };
    toggleSiteHandler = (state: IAccessLevelSelectionState): IAccessLevelSelectionState => {
        state.siteChecked = !state.siteChecked;
        return state;
    };
    toggleGroupHandler = (state: IAccessLevelSelectionState): IAccessLevelSelectionState => {
        state.groupChecked = !state.groupChecked;
        return state;
    };
    toggleUserHandler = (state: IAccessLevelSelectionState): IAccessLevelSelectionState => {
        state.userChecked = !state.userChecked;
        return state;
    };
}
